import { render, staticRenderFns } from "./ResourceRequestSubmitModal.vue?vue&type=template&id=db62c0ac"
import script from "./ResourceRequestSubmitModal.vue?vue&type=script&lang=js"
export * from "./ResourceRequestSubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports